export default __webpack_public_path__ + "static/media/details.644cbcb9.svg";